export enum Gender {
    male = 1,
    female,
    undisclosed
}

export const getGenderNameRu = (gender: Gender) => {
    switch (gender) {
        case Gender.male: return 'мужской'; break;
        case Gender.female: return 'женский'; break;
        default: return 'не разглашается';
    }
}